import { Helmet } from 'react-helmet'
import ForgotPasswordForm from 'components/forgotPassword'

const ForgotPassword = () => {
  return (
    <>
      <Helmet>
        <title>ORMS Forgot Password</title>
      </Helmet>
      <div className="flex w-full items-center justify-center">
        <ForgotPasswordForm />
      </div>
    </>
  )
}

export default ForgotPassword
